import React, {
    ReactNode,
    useMemo,
    useState,
} from 'react'

import Layout from '@src/Layout'
import Header from '@src/Layout/components/Header'
import Button from '@src/shared-components/Button'
import MainPopup from '@src/MainPopup/MainPopup'
import useT from '@src/hooks/useT/useT'
import Progress from '@src/shared-components/Progress'
import {
    getProgressOptions,
} from '@src/pages/ScanQR/components/ScanQR'

import classes from './InstallGatewayLayout.style'

type Props = {
    onNextClick: () => void,
    onBackClick: () => void,
    children: ReactNode,
    nextButtonText: ReactNode,
}

const InstallGatewayLayout = ({
    onNextClick,
    onBackClick,
    children,
    nextButtonText,
}: Props): JSX.Element => {
    const {
        t,
    } = useT()
    const [
        isPopupOpened,
        setIsPopupOpened,
    ] = useState(false)

    const progressOptions = useMemo(() => {
        return getProgressOptions(t)
    }, [t])

    return (
        <Layout
            header={(
                <Header
                    title={t('INSTALL_GATEWAY')}
                    onMenuClick={() => {
                        return setIsPopupOpened((open) => {
                            return !open
                        })
                    }}
                />
            )}
            footer={(
                <>
                    <Button
                        variant="primary"
                        onClick={onNextClick}
                    >
                        {nextButtonText}
                    </Button>
                    <Button
                        variant="primary-outlined"
                        onClick={onBackClick}
                    >
                        {t('BACK')}
                    </Button>
                </>
            )}
        >
            <div css={classes.root}>
                <MainPopup
                    isOpen={isPopupOpened}
                    onClose={() => {
                        return setIsPopupOpened(false)
                    }}
                />
                <div css={classes.progress}>
                    <Progress
                        options={progressOptions}
                        currentStep={1}
                    />
                </div>
                {children}
            </div>
        </Layout>
    )
}

export default InstallGatewayLayout
